module.exports = __webpack_public_path__ + "static/media/art-artistic-artsy.2fd58b21.png";